var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    [
      _c(
        "el-col",
        { attrs: { span: 12 } },
        [
          _c("p", [_vm._v("需要具有某项权限")]),
          _c("p", [_vm._v("v-permission=\"'system:user:remove'\"")]),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: "system:user:remove",
                  expression: "'system:user:remove'"
                }
              ]
            },
            [_vm._v("Button")]
          ),
          _c("p", [_vm._v("需要具有至少一项权限")]),
          _c("p", [
            _vm._v(
              "v-permission=\"['system:user:remove', 'system:user:edit']\""
            )
          ]),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: ["system:user:remove", "system:user:edit"],
                  expression: "['system:user:remove', 'system:user:edit']"
                }
              ]
            },
            [_vm._v("Button")]
          ),
          _c("p", [_vm._v("需要具有给出的全部权限")]),
          _c("p", [
            _vm._v(
              "v-permission.all=\"['system:user:remove', 'system:user:edit']\""
            )
          ]),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission.all",
                  value: ["system:user:remove", "system:user:edit"],
                  expression: "['system:user:remove', 'system:user:edit']",
                  modifiers: { all: true }
                }
              ]
            },
            [_vm._v("Button")]
          )
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 12 } },
        [
          _c("p", [_vm._v("不允许具有某项权限")]),
          _c("p", [_vm._v("v-permission.not=\"'system:user:remove'\"")]),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission.not",
                  value: "system:user:remove",
                  expression: "'system:user:remove'",
                  modifiers: { not: true }
                }
              ]
            },
            [_vm._v("Button")]
          ),
          _c("p", [_vm._v("不允许具有其中任意一项权限")]),
          _c("p", [
            _vm._v(
              "v-permission.not=\"['system:user:remove', 'system:user:edit']\""
            )
          ]),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission.not",
                  value: ["system:user:remove", "system:user:edit"],
                  expression: "['system:user:remove', 'system:user:edit']",
                  modifiers: { not: true }
                }
              ]
            },
            [_vm._v("Button")]
          ),
          _c("p", [_vm._v("至少不具有其中一项权限")]),
          _c("p", [
            _vm._v(
              "v-permission.not.all=\"['system:user:remove', 'system:user:edit']\""
            )
          ]),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission.not.all",
                  value: ["system:user:remove", "system:user:edit"],
                  expression: "['system:user:remove', 'system:user:edit']",
                  modifiers: { not: true, all: true }
                }
              ]
            },
            [_vm._v("Button")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }